// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyStartSessionModelResponse {
    static getAttributeTypeMap() {
        return SurveyStartSessionModelResponse.attributeTypeMap;
    }
}
SurveyStartSessionModelResponse.discriminator = undefined;
SurveyStartSessionModelResponse.additionalProperties = false;
SurveyStartSessionModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SurveyStartSessionResponseModel"
    },
];
//# sourceMappingURL=surveyStartSessionModelResponse.js.map